import React from 'react';
import { FileTextIcon, DownloadIcon, BarChartIcon } from 'lucide-react';
export function Reports() {
  return <div className="space-y-6" data-id="element-526">
      {/* Configurator */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-527">
        <h2 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-528">
          <FileTextIcon className="w-5 h-5" style={{
          color: '#134073'
        }} data-id="element-529" />
          Generador de Reportes
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-530">
          <div data-id="element-531">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-532">
              Tipo de Reporte
            </label>
            <select className="w-full border border-gray-300 rounded-lg px-4 py-2.5 bg-white focus:ring-2 focus:outline-none" style={{
            focusRingColor: '#3d99d2'
          }} data-id="element-533">
              <option data-id="element-534">Por Área / Servicio</option>
              <option data-id="element-535">Por Rango de Fechas</option>
              <option data-id="element-536">Por Categoría de Prenda</option>
              <option data-id="element-537">Por Recolector</option>
            </select>
          </div>

          <div data-id="element-538">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-539">
              Fecha Inicio
            </label>
            <input type="date" className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:outline-none" data-id="element-540" />
          </div>

          <div data-id="element-541">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-542">
              Fecha Fin
            </label>
            <input type="date" className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:outline-none" data-id="element-543" />
          </div>
        </div>

        <div className="flex justify-end" data-id="element-544">
          <button className="flex items-center gap-2 px-6 py-2.5 rounded-lg text-white font-bold shadow-sm hover:opacity-90 transition-colors" style={{
          backgroundColor: '#134073'
        }} data-id="element-545">
            <BarChartIcon className="w-5 h-5" data-id="element-546" />
            Generar Reporte
          </button>
        </div>
      </div>

      {/* Results Placeholder */}
      <div className="bg-gray-50 rounded-xl border-2 border-dashed border-gray-300 p-12 flex flex-col items-center justify-center text-center" data-id="element-547">
        <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm" data-id="element-548">
          <FileTextIcon className="w-8 h-8 text-gray-400" data-id="element-549" />
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-1" data-id="element-550">
          No hay reporte generado
        </h3>
        <p className="text-gray-500 max-w-sm" data-id="element-551">
          Seleccione los parámetros arriba y haga clic en "Generar Reporte" para
          ver los resultados.
        </p>
      </div>
    </div>;
}